import { css } from "styled-components";

export const size = {
  notSupportNum: 279,
  notSupport: "280px", // samsung fold
  mobile: "550px", // samsung s20 ultra
  tablet: "1024px",
  desktop: "2560px",
};

export const mobile = (inner: any) => css`
  @media (min-width: ${size.notSupport}) and (max-width: ${size.mobile}) {
    ${inner};
  }
`;
export const tablet = (inner: any) => css`
  @media (min-width: ${size.mobile}) and (max-width: ${size.tablet}) {
    ${inner};
  }
`;
export const desktop = (inner: any) => css`
  @media (min-width: ${size.tablet}) and (max-width: ${size.desktop}) {
    ${inner};
  }
`;
